import type { ElementRef, OnInit } from '@angular/core';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { EMPTY_ARRAY_LENGTH } from '@modeso/aumico-lib-core-fe';
import { ItemType } from '@modeso/types__aumico-lib-annualreport-be';

@Component({
    selector: 'inline-table-cell-edit',
    templateUrl: './inline-table-cell-edit.component.html',
    styleUrls: ['./inline-table-cell-edit.component.scss'],
})
export class InlineTableCellEditComponent implements OnInit {
    @Input() value: string;
    @Input() isEditing = false;
    @Input() type: ItemType | undefined;
    @ViewChild('input') input: ElementRef<HTMLInputElement>;
    @Output() save = new EventEmitter<string>();

    public editValue: string | undefined;

    constructor(private readonly matIconRegistry: MatIconRegistry, private readonly domSanitizer: DomSanitizer) {
        this.matIconRegistry.addSvgIcon(
            'save',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/aumico-pattern-icon-save.svg'),
        );
    }

    ngOnInit(): void {
        this.editValue = this.value;
        if (this.isEditing) {
            this.setFocusOnInput();
        }
    }

    preventDefault(event: KeyboardEvent | MouseEvent): void {
        event.stopImmediatePropagation();
        event.stopPropagation();
    }
    handleOnSave(): void {
        this.isEditing = false;
        if (this.editValue != null && this.editValue.trim().length > EMPTY_ARRAY_LENGTH) {
            this.value = this.editValue;
        } else {
            this.editValue = this.value;
        }
        this.save.emit(this.value);
    }

    handleOnEdit(): void {
        this.isEditing = !this.isEditing;
        if (this.isEditing) {
            this.setFocusOnInput();
        }
    }

    private setFocusOnInput(): void {
        const immediate = 0;
        setTimeout(() => {
            this.input.nativeElement.focus();
        }, immediate);
    }
}
